/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/phoneVerificationMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a PhoneVerification. */
export class PhoneVerification {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a PhoneVerification.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls the VerificationClient API to generate a security code and sends it to the phone number.
   * @summary Generates a security code that is sent to the phone number.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  generateCode(options?: Models.PhoneVerificationGenerateCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  generateCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  generateCode(options: Models.PhoneVerificationGenerateCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  generateCode(options?: Models.PhoneVerificationGenerateCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      generateCodeOperationSpec,
      callback);
  }

  /**
   * Calls the VerificationClient API to verify the security code of the phone number.
   * @summary Verifies the security code for the phone number.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  verifyCode(options?: Models.PhoneVerificationVerifyCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  verifyCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyCode(options: Models.PhoneVerificationVerifyCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  verifyCode(options?: Models.PhoneVerificationVerifyCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      verifyCodeOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const generateCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/IdentityTheftMonitoring/phone/code",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PhoneGenerateCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const verifyCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/IdentityTheftMonitoring/phone/verify",
  queryParameters: [
    Parameters.updateExternal
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PhoneVerificationCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
